<div class="row weighting-container"
    *ngIf="!portfolioModel?.profileData?.is529 && !portfolioModel?.profileData?.isFundOfFunds">
    <div class="col-sm-12"
        *ngIf="!!showSectorsTab || !!creditQualityData?.length || !!regionData?.length || !!marketData?.length || !!issuerTypeData?.length || !!maturityData?.length || !!couponData?.length; else noWeightingsData">
        <h5 class="rps-heading-five">Weighted exposures</h5>
        <ng-container *ngIf="!!weightingData; else noweightingData">
            <p class="date rps-paragraph-two rps-grey" *ngIf="!!weightingData[activeTabName]?.asOfDate"
                data-rpa-tag-id="weightingDate">as of
                {{ weightingData[activeTabName]?.asOfDate | ESTPipe }}</p>
        </ng-container>
        <ng-template #noweightingData>
            <p class="date rps-heading-two rps-grey">as of -</p>
        </ng-template>

        <div #weightedExposuresTabs>
            <c11n-tabs (activeItemChange)="onTabClick($event)" [smallResponsiveBreakpoint]=changeView()
                variant="left-aligned" overflowOption="nav-overflow" hasAnimation="true" id="weighted-exposures-tab">
                <c11n-tab-panel [id]="displayedTabs[0]?.tabPanelId"
                    [attr.data-rpa-tag-id]="'pc-we-tab-'+(displayedTabs[0]?.name)" [labelText]="displayedTabs[0]?.name"
                    *ngIf="!!showSectorsTab">
                    <div class="c11n-text-crop" *ngIf="activeTabName === displayedTabs[0]?.tabClass">
                        <ng-container *ngIf="false else c11nTabContent"></ng-container>
                    </div>
                </c11n-tab-panel>
                <c11n-tab-panel [id]="displayedTabs[1]?.tabPanelId"
                    [attr.data-rpa-tag-id]="'pc-we-tab-'+(displayedTabs[1]?.name)" [labelText]="displayedTabs[1]?.name"
                    *ngIf="!!displayedTabs[1] && !!regionData?.length">
                    <div class="c11n-text-crop" *ngIf="activeTabName === displayedTabs[1]?.name">
                        <ng-container
                            [ngClass]="activeTabName === displayedTabs[1]?.tabClass ? 'tab-active' : 'tab-inactive'"
                            *ngIf="false else c11nTabContent"></ng-container>
                    </div>
                </c11n-tab-panel>
                <c11n-tab-panel [id]="displayedTabs[2]?.tabPanelId"
                    [attr.data-rpa-tag-id]="'pc-we-tab-'+(displayedTabs[2]?.name)" [labelText]="displayedTabs[2]?.name"
                    *ngIf="!!marketData?.length">
                    <div class="c11n-text-crop" *ngIf="activeTabName === displayedTabs[2]?.name">
                        <ng-container *ngIf="false else c11nTabContent"></ng-container>
                    </div>
                </c11n-tab-panel>
                <c11n-tab-panel [id]="displayedTabs[4]?.tabPanelId"
                    [attr.data-rpa-tag-id]="'pc-we-tab-'+(displayedTabs[4]?.name)" [labelText]="displayedTabs[4]?.name"
                    *ngIf="!!creditQualityData?.length && showCreditQualityTab">
                    <div class="c11n-text-crop" *ngIf="activeTabName === displayedTabs[4]?.tabClass">
                        <ng-container *ngIf="false else c11nTabContent"></ng-container>
                    </div>
                </c11n-tab-panel>
                <c11n-tab-panel [id]="displayedTabs[3]?.tabPanelId"
                    [attr.data-rpa-tag-id]="'pc-we-tab-'+(displayedTabs[3]?.name)" [labelText]="displayedTabs[3]?.name"
                    *ngIf="!!issuerTypeData?.length && showIssuerTypeTab">
                    <div class="c11n-text-crop" *ngIf="activeTabName === displayedTabs[3]?.tabClass">
                        <ng-container *ngIf="false else c11nTabContent"></ng-container>
                    </div>
                </c11n-tab-panel>
                <c11n-tab-panel [id]="displayedTabs[5]?.tabPanelId"
                    [attr.data-rpa-tag-id]="'pc-we-tab-'+(displayedTabs[5]?.name)" [labelText]="displayedTabs[5]?.name"
                    *ngIf="!!maturityData?.length && showMaturityTab">
                    <div class="c11n-text-crop" *ngIf="activeTabName === displayedTabs[5]?.tabClass">
                        <ng-container *ngIf="false else c11nTabContent"></ng-container>
                    </div>
                </c11n-tab-panel>
                <c11n-tab-panel [id]="displayedTabs[6]?.tabPanelId"
                    [attr.data-rpa-tag-id]="'pc-we-tab-'+(displayedTabs[6]?.name)" [labelText]="displayedTabs[6]?.name"
                    *ngIf="!!couponData?.length && showCouponTab">
                    <div class="c11n-text-crop" *ngIf="activeTabName === displayedTabs[6]?.tabClass">
                        <ng-container *ngIf="false else c11nTabContent"></ng-container>
                    </div>
                </c11n-tab-panel>
                <ng-template #c11nTabContent>
                    <div (window:resize)="findScreenSize()" id="weighted-exposures-tabpanel">
                        <div class="weighting-chart-table-section" *ngIf="chartAndTable?.length;else noData">
                            <div class="weighted-market-chart">
                                <exemplar-donut-chart [chartId]="chartId" [tableId]="tableId"
                                    [chartData]="chartAndTable" [decimals]="2" [selectPathData]="selectPathData">
                                </exemplar-donut-chart>
                            </div>
                            <div *ngIf="!!dataSource?.filteredData?.length" id="{{tableId}}ExportDiv"
                                [ngClass]="{'is-not-sticky': tableHasThreeColumns()}">
                                <!-- <button id="right-btn" aria-label="Scroll Right" (click)="moveRight()"
                                    *ngIf="showRightButton && innerWidth<=576">
                                    &RightAngleBracket;
                                </button>
                                <button id="left-btn" aria-label="Scroll Left" (click)="moveLeft()"
                                    *ngIf="scrollBarPosition>0 && innerWidth<=576">
                                    &LeftAngleBracket;
                                </button> -->
                                <mat-table id="{{tableId}}"
                                    [dataSource]="dataSource" matSort matSortActive="name">
                                    <ng-container matColumnDef="conByStateColor" sticky>
                                        <mat-header-cell *matHeaderCellDef><span
                                                [innerHTML]=""></span></mat-header-cell>
                                        <mat-cell
                                            *matCellDef="let row; let indexId = index">
                                            <svg id="cr{{indexId}}">
                                                <circle cx="10" cy="10" r="5" />
                                            </svg>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="name" sticky>
                                        <mat-header-cell *matHeaderCellDef
                                            mat-sort-header>
                                            <span
                                                *ngIf="activeTabName !=='Markets' && activeTabName !=='Maturity' ">{{activeTabName}}<sup
                                                    *ngIf="activeTabName === 'Sectors'">{{sectorFootnote?.id}}</sup><sup
                                                    *ngIf="activeTabName === 'Credit rating'">{{creditQualityFootNote?.id}}</sup></span>
                                            <span *ngIf="activeTabName ==='Maturity' "><a class="link dialog-button"
                                                    tabindex="0" role="button"
                                                    (click)="setDialogInfo('Maturity');weightingExposureDialog.openModalDialog();"
                                                    href="javascript:void(0)">{{activeTabName}}</a></span>
                                            <span *ngIf="activeTabName ==='Markets' "> COUNTRY </span>
                                        </mat-header-cell>
                                        <mat-cell id="donutChartContentName{{indexId}}"
                                            *matCellDef="let row; let indexId = index"><span
                                                data-rpa-tag-id="pc-we-name">{{row.name}}</span></mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="value">
                                        <mat-header-cell
                                            *matHeaderCellDef mat-sort-header>
                                            <span
                                                *ngIf="!portfolioModel?.profileData?.isMarketNeutralFund && activeTabName !=='Markets' && activeTabName !== 'Credit rating' && activeTabName !== 'Issuer' && activeTabName !== 'Maturity' && activeTabName !== 'Coupon' ">{{tickerColName}}</span>
                                            <span
                                                *ngIf="!portfolioModel?.profileData?.isMarketNeutralFund && (activeTabName ==='Markets' || activeTabName === 'Credit rating' || activeTabName === 'Issuer' || activeTabName === 'Maturity' || activeTabName === 'Coupon' ) "
                                                data-rpa-tag-id="pc-we-fundPercent">%
                                                of fund</span>
                                            <span *ngIf="portfolioModel?.profileData?.isMarketNeutralFund">Long</span>
                                        </mat-header-cell>
                                        <mat-cell id="donutChartContentValue{{indexId}}"
                                            *matCellDef="let row; let indexId = index">
                                            <span data-rpa-tag-id="pc-we-pctOfFund">{{row.value | percentage: 2 |
                                                emDash}}</span>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="benchmark">
                                        <mat-header-cell
                                            *matHeaderCellDef mat-sort-header
                                            [hidden]="(portfolioModel?.profileData?.isExternalFund)">
                                            <span *ngIf="(portfolioModel?.profileData?.isMarketNeutralFund)">Short</span>
                                            <span *ngIf="(!portfolioModel?.profileData?.isMarketNeutralFund)">
                                                Benchmark
                                                <c11n-tooltip colorMode="on-light" [autoOrientation]="false"
                                                    direction="left" labelText="Benchmark">
                                                    <span c11nTooltipContent>{{ weightingData[activeTabName]?.shortName
                                                        }}</span>
                                                </c11n-tooltip>
                                            </span>
                                        </mat-header-cell>
                                        <mat-cell id="donutChartContentBenchMark{{indexId}}"
                                            [hidden]="(portfolioModel?.profileData?.isExternalFund)"
                                            *matCellDef="let row; let indexId = index">
                                            <span
                                                data-rpa-tag-id="pc-we-pctOfBenchmark">{{row.benchmark | percentage: 2 |
                                                emDash}}</span>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="weight">
                                        <mat-header-cell
                                            [hidden]="(portfolioModel?.profileData?.isMarketNeutralFund) || (portfolioModel?.profileData?.isExternalFund)"
                                            *matHeaderCellDef mat-sort-header>
                                            <span class="inner-span-weight">+/-
                                                Weight
                                            </span>
                                        </mat-header-cell>
                                        <mat-cell
                                            [hidden]="(portfolioModel?.profileData?.isMarketNeutralFund) || (portfolioModel?.profileData?.isExternalFund)"
                                            id="donutChartContentWeight{{indexId}}"
                                            *matCellDef="let row; let indexId = index">
                                            <span
                                                data-rpa-tag-id="pc-we-plusMinusWeight">{{row.weight | percentage: 2 |
                                                emDash}}</span>
                                        </mat-cell>
                                    </ng-container>
                                    <mat-header-row class="table-top-row" *matHeaderRowDef="displayedColumns">
                                    </mat-header-row>
                                    <mat-row [attr.data-rpa-tag-id]=" 'pc-we-row-' + (row.name | trim)"
                                        id="{{row.id}}TR" class="table-mat-row"
                                        *matRowDef="let row; columns: displayedColumns;"
                                        (mouseover)="selectPath(row.id, $event)"></mat-row>
                                </mat-table>

                                <c11n-modal-dialog modalId="WeightingExposurePriceModal" [headingText]="dialogTitle"
                                    #weightingExposureDialog>
                                    <div c11n-modal-dialog-body>
                                        <p class="weighted-exposures-gap"><b>Distribution by Effective Maturity (taxable
                                                bond funds and balanced
                                                funds except Tax-Managed Balanced)</b>
                                        </p>
                                        <p [innerHTML]="distributionEffectiveMaturity?.contentValue"></p>
                                        <p class="weighted-exposures-gap"><b> Distribution by Stated Maturity (municipal
                                                bond funds and Tax-Managed
                                                Balanced)</b>
                                        </p>
                                        <p [innerHTML]="distributionStateMaturity?.contentValue"></p>
                                    </div>
                                </c11n-modal-dialog>

                            </div>
                        </div>
                        <ng-template #noData>
                            <h2 class="rps-heading-two">The fund includes no holdings of this type.</h2>
                        </ng-template>
                    </div>
                </ng-template>
            </c11n-tabs>
            <ng-template #noData>
                <h2 class="rps-heading-two">The fund includes no holdings of this type.</h2>
            </ng-template>
        </div>
        <p class="weighted-exposures rps-paragraph-one rps-grey"
            [innerHTML]="disclaimerWeightedExposures?.contentValue"></p>
    </div>
    <ng-template #noWeightingsData>
        <div class="col-sm-12">
            <span class="sector">Weighted exposures</span>
            <p class="no-data">This information is temporarily unavailable.</p>
        </div>
    </ng-template>
</div>